export class AppConfig {
    app: string | null = null;
    server: string | null = null;
}